import { createClient } from '@supabase/supabase-js'
import { config, configurationError } from '../config.js'

let client = null

export function getSupabase() {
  if (config.e2e) return null
  if (configurationError()) return null
  if (!client) {
    client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: { flowType: 'pkce', persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  }
  return client
}

export async function accessToken() {
  // e2e bypass has no real Supabase session (getSupabase() returns null
  // above), but gatewayRequest()/relayFetch() both gate on a truthy token
  // before firing fetch — without a stand-in here, Playwright's page.route
  // mocks for /runware/inference and /media/relay would never see a request.
  // Mirrors the fake e2e session already used in canvas-entry.js/app.jsx.
  if (config.e2e) return 'e2e-bypass-token'
  const sb = getSupabase()
  if (!sb) return null
  const { data } = await sb.auth.getSession()
  return data.session?.access_token || null
}
